<template>
	<div>
		<!-- Swap Dialog -->
        <modal
            class="swap-modal"
            size="small-tall"
			:hide-footer="true"
			@close="close">
            <template slot="header">
                <h5 class="mb-0">{{ $t('Credits') }}</h5>
            </template>
            <template slot="body">
				<div class="pb-5">
					<div class="text-left mt-4">
						<img src="/img/logo/grafias_medium_ondark.png" alt="xls" width="200px"/>
					</div>
					<div class="sub-title mb-4">
						{{$t('Ver.')}} {{appVersion}}
					</div>
					<p class="mb-2 text-left text-base mb-4">
						{{ $t('Grafias proudly build by Supersource.Inc') }}
					</p>
					<p class="mb-2 text-left text-base sub-title">
						{{ $t('Credits') }}:
					</p>
					<p class="mb-2 text-left text-base">
						{{ $t('Lottie - Airbnb, inc.') }}
					</p>
					<p class="mb-2 text-left text-base">
						{{ $t('Bodymovin - Hernan Torrisi') }}
					</p>
					<p class="pb-5 text-left text-base">
						{{ $t('Unsplash - ') }}<span><a href="https://unsplash.com" target="_blank">unsplash.com</a></span>
					</p>
				</div>
            </template>
		</modal>
	</div>
</template>

<script>

import Modal from '@/components/Modal.vue';
import {
	appVersion,
} from '@/lib/statics';

export default {
	name: 'ModalCreditUser',
	components: {
		Modal,
	},
	props: {},
	mounted() {
	},
	data: () => ({
		isTakeOver: false,
	}),
	methods: {
		close() {
			this.$emit('close');
		},
	},
	computed: {
		appVersion() {
			return appVersion;
		},
	},
};
</script>

<style lang="scss" scoped>
.material-icons-group {
    font-family: 'Material Icons';
    font-weight: normal;
    font-style: normal;
    padding: 0px;
    margin: 0px;
    font-size: 80px;
	color: #FFA800;
    line-height: 1;
    letter-spacing: normal;
    text-transform: none;
    display: inline-block;
    white-space: nowrap;
    word-wrap: normal;
    direction: ltr;
    -webkit-font-feature-settings: 'liga';
    -webkit-font-smoothing: antialiased;
}
.material-icons-swap {
    font-family: 'Material Icons';
    position: rela;
    padding: 0px;
    margin: 0px;
    font-size: 60px;
	color: #FFA800;
    line-height: 1;
}
.wrapper-offline{
		text-align: center!important;
	}
</style>
